import { render, staticRenderFns } from "./ListAnnotations.vue?vue&type=template&id=49f26d16&scoped=true"
import script from "./ListAnnotations.vue?vue&type=script&lang=js"
export * from "./ListAnnotations.vue?vue&type=script&lang=js"
import style0 from "./ListAnnotations.vue?vue&type=style&index=0&id=49f26d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f26d16",
  null
  
)

export default component.exports